// libs
import { styled } from '@nykaa/ui-components';

// components
import { Dots as BaseDots } from 'shared/components/Carousel';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

export const Placeholder = styled.div<{ backgroundImage: string }>`
  width: 480px;
  height: 639px;
  background-color: ${({ theme }) => theme.colors.surface20};

  ${({ backgroundImage }) => `
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url(${encodeURI(backgroundImage)});
    `}

  @media (max-width: 1100px) {
    width: 594px;
    height: 792px;
    margin: 0 auto;
  }

  @media (max-width: ${BREAKPOINTS.TABLET}px) {
    width: 100%;
    padding-top: 133.33%;
    height: auto;
  }

  @media (max-width: ${BREAKPOINTS.MOBILE}px) {
    width: 100%;
    padding-top: 133.33%;
    height: auto;
  }
`;

export const ImageContent = styled.div`
  position: relative;
  width: 480px;
  height: 639px;

  @media (max-width: 1100px) {
    width: 594px;
    height: auto;
  }

  @media (max-width: ${BREAKPOINTS.TABLET}px) {
    width: 100%;
    height: auto;
  }
`;

export const dotClassName = 'pdp-img-dot';
export const videoDotClassName = 'pdp-vdo-dot';
export const activeClassName = 'pdp-img-active';
export const Dots = styled(BaseDots)`
  background: transparent;
  bottom: -24px;
  height: 24px;

  & .${dotClassName} {
    height: 6px;
    width: 6px;
    background: rgba(0, 0, 0, 0.15);
    margin-right: ${({ theme }) => theme.spacing.spacing40};
    border-radius: ${({ theme }) => theme.borders.radiusFull};
  }

  .${videoDotClassName} {
    border-radius: initial;
    box-sizing: border-box;
    border: initial;
    border-width: 3px 0 3px 6px;
    border-style: solid;
    background-color: transparent;
    border-color: transparent transparent transparent rgba(0, 0, 0, 0.15);
  }

  .${activeClassName} {
    background: rgba(0, 0, 0, 0.64);

    &.${videoDotClassName} {
      border-color: transparent transparent transparent rgba(0, 0, 0, 0.64);
      background: transparent;
    }
  }
`;
